import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { FaBars, FaTimes, FaEnvelope, FaPhoneAlt } from "react-icons/fa"; // Added email and phone icons

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleContact = () => {
    setShowContact(!showContact);
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      {/* Left Section: Logo or Name */}
      <div className="navbar-left">
        <span className="logo-text"></span>
      </div>

      {/* Center Navigation Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li>
          <a
            href="#home"
            className="back-to-top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Home
          </a>
        </li>
        
        <li>
          <a
            href="#skills"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("skills");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Skills
          </a>

        </li>

        <li>
          <a
            href="#projects"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("projects");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Projects
          </a>

        </li>

        <li>
          <a
            href="#experience"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("experience");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Experience
          </a>

        </li>

        <li>
          <a
            href="#highlights"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("highlights");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Highlights
          </a>

        </li>
        
        <li>
          <button 
            className={`contact-button ${showContact ? "active" : ""}`} 
            onClick={toggleContact}
          >
            Let's Connect
          </button>
        </li>
      </ul>

      {/* Right Section: Social Links & Mobile Menu Toggle */}
      <div className="navbar-right">
        {/* Contact Popup */}
                {/* Contact Popup */}
        <div className={`contact-popup ${showContact ? "show" : ""}`}>
          <button className="close-popup" onClick={toggleContact}>&times;</button>
          <p>Want to work together? Reach out to me:</p>
          <a href="mailto:monami.somsaha@gmail.com" className="contact-link">
            <FaEnvelope /> monami.somsaha@gmail.com
          </a>
          <a href="tel:+917002252743" className="contact-link">
            <FaPhoneAlt /> +91 7002252743
          </a>
        </div>
        {/* Mobile Menu Toggle Button */}
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Social Links */}
        <div className="social-links">
          <a
            href="https://www.linkedin.com/in/monami-somsaha"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn Profile"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/linkedin-circled--v1.png"
              alt="LinkedIn"
            />
          </a>
          <a
            href="https://github.com/monami-somsaha"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub Profile"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/github.png"
              alt="GitHub"
            />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;